import React from "react";
import { StyleSheet, View, Platform } from "react-native";
import { useSelector } from "react-redux";
import LHSectionHeader from "../../../components/LHSectionHeader";
import LHMiscellaneousObservations from "../../../components/LHMiscellaneousObservations.fixed.new";
import { selectWalkState } from "../../../store/slices/leadershipWalkRedirectSlice";
import FontFamily from "../../../constants/fonts";
import { useTheme } from "../../../theme";

const LeadershipWalkMiscellaneousObservations: React.FC = () => {
  const { colors, resolvedTheme } = useTheme();
  const isDarkTheme = resolvedTheme === "dark";
  const walkState = useSelector(selectWalkState);

  return (
    <View style={styles.container}>
      <View style={styles.miscellaneousObservationsWrapper}>
        {/* Card with integrated header and body */}
        <View style={styles.cardContainer}>
          <LHSectionHeader
            title="Miscellaneous Observations"
            containerStyle={{
              ...styles.sectionHeader,
              backgroundColor: colors.brand.primary,
            }}
            textStyle={styles.header1text}
          />

          <View
            style={[
              styles.miscellaneousObservationsContainer,
              isDarkTheme && {
                borderColor: colors.border.default,
                backgroundColor: colors.background.surface,
              },
            ]}
          >
            <LHMiscellaneousObservations
              disabled={walkState === "completed"}
              stateKey="leadershipWalk"
              containerName="leadership"
            />
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: "relative",
    zIndex: 1,
  },
  cardContainer: {
    borderRadius: 6,
    // allow header to expand beyond original bounds when wrapping
    overflow: Platform.OS === "ios" ? "visible" : "hidden",
  },
  sectionHeader: {
    backgroundColor: "#3582E6",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    // use minHeight so header can expand to 2 lines when needed
    minHeight: 48,
  },
  header1text: {
    fontSize: 14,
    fontWeight: "700",
    lineHeight: 20,
    fontFamily: FontFamily.bold,
  },
  miscellaneousObservationsContainer: {
    borderColor: "#e9ecef",
    borderWidth: 1,
    borderTopWidth: 0,
    borderRadius: 6,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    backgroundColor: "white",
    padding: 16,
  },
  miscellaneousObservationsWrapper: {
    marginTop: 24,
  },
});

export default LeadershipWalkMiscellaneousObservations;
